import {
  required,
  shape,
  concatFailure,
  unique,
  items,
  fromParent,
  when,
  atLeastOne,
  fromModel,
  between,
  greaterThan,
  Validator, 
  stopOnFirstFailure,
  Success, 
  Failure, 
  ValidationError
} from '@totalsoft/pure-validations';
import { filterConditionContainsConditionNumbers } from 'utils/customValidators';
import i18next from 'i18next';

export const financialProductRuleValidator = shape({
  ruleCode: required
});

export const financialProductRuleListValidator = fromModel(model =>
  shape({
    financialProductRules: uniqueGeneralRule(model.currentRuleId, model.currentGeneralRuleYN)
  })
);

export const uniqueGeneralRule = (currentRuleId, currentGeneralRuleYN) =>
Validator(function uniqueGeneralRule(rules) {
  if ((!rules || rules?.length <= 1) || !currentGeneralRuleYN)  return Success;
  
  if(rules.find(x=> x.financialProductRuleId !== currentRuleId && x.generalYN)) return Failure(ValidationError(i18next.t('FinancialProduct.Details.Rules.GeneralData.GeneralRuleYNUniqueMessage')));

  return Success;
});



export const financialProductRuleFiltersValidator = concatFailure(
  unique(x => x.orderNo || {}, 'EntityFilter.Validators.OrderNoUnique'),
  items(
    shape({
      orderNo: required,
      paramId: required,
      operatorId: required,
      filterValue: fromParent(parent => required |> when(parent.paramIsList === false || parent.operatorIsMultipleSelection === false)),
      filterValues: fromParent(
        parent =>
          [atLeastOne, required |> items]
          |> concatFailure
          |> when(parent.paramIsList === true && parent.operatorIsMultipleSelection === true)
      )
    })
  )
);

export const financialProductRuleOutputDataValidator = concatFailure(
  items(
    shape({
      defaultValue: concatFailure(
        fromParent(parent => between(parseInt(parent.minValue), parseInt(parent.maxValue))),
        required
      ),
      minValue: required,
      maxValue: required,
      paramId: required
    })
  ),
  unique(x => x.paramId)
);

export const financialProductRuleOutputDictionaryValidator = concatFailure(
  items(
    shape({
      paramId: required,
      filterValueId: required,
      filterValue: required
    })
  ),
  unique(x => x.paramId)
);

export const financialProductRuleCommissionsValidator = concatFailure(unique(x => x.commissionId));

export const financialProductRuleCommissionValidator = concatFailure(
    shape({
      commissionId: required,
      commissionDefaultPercent: fromParent(model =>
        concatFailure(between(1, 100) |> when(model?.usesPercent === true || (model?.usesPercent === false && model?.usesValue === false)))
      ),
      commissionDefaultValue: fromParent(model =>
        concatFailure(greaterThan(0) |> when(model?.usesValue === true || (model?.usesPercent === false && model?.usesValue === false)))
      ),
      assignToRoleId: required,
      appliedToId: required,
      calculationMethodId: required
    })
);

export const financialProductRuleIncomeValidator = concatFailure(
  items(
    shape({
      incomeTypeId: required,
      value: concatFailure(greaterThan(0), required),
      currencyId: required
    })
  ),
  unique(x => x.incomeTypeId)
);

export const financialProductRuleServiceValidator = concatFailure(
  items(
    shape({
      serviceTypeId: required,
      percentOrValue: [required, greaterThan(0)] |> stopOnFirstFailure,
      calcTypeId: required,
      periodicity: [required, greaterThan(0)] |> stopOnFirstFailure
    })
  ),
  unique(x => x.serviceTypeId)
);

export const ruleConditionValidator = fromModel(model =>
  shape({
    value: filterConditionContainsConditionNumbers(model.conditionNumbers)
  })
);
